export default __webpack_public_path__ + "static/media/slider-3.b47a410c.jpg";